import { render } from "./RCBCOpeningView.vue?vue&type=template&id=fce6ef64&scoped=true"
import script from "./RCBCOpeningView.vue?vue&type=script&lang=js"
export * from "./RCBCOpeningView.vue?vue&type=script&lang=js"

import "./RCBCOpeningView.vue?vue&type=style&index=0&id=fce6ef64&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce6ef64"]])

export default __exports__